"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _IconButtonWithTooltip = _interopRequireDefault(require("@sprinx/react-mui-components/IconButtonWithTooltip"));

var _AppBarActionCart = _interopRequireDefault(require("@sprinx/react-shopping-cart/AppBarActionCart"));

var _BasketIcon = _interopRequireDefault(require("../../icons/BasketIcon"));

var _AppBarActionGlobalSearchComposed = _interopRequireDefault(require("./AppBarActionGlobalSearchComposed"));

var _AppBarActionNarrow = _interopRequireDefault(require("./AppBarActionNarrow"));

var _MobileMainNavigation = _interopRequireDefault(require("./MobileMainNavigation"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _appHeader;

  return {
    root: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      position: 'fixed',
      zIndex: theme.zIndex.appBar,
      top: 0,
      left: 0,
      right: 0,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      background: theme.palette.common.white,
      boxShadow: theme.shadows[6]
    }, theme.breakpoints.down('sm'), {
      paddingBottom: 0,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }),
    menuButton: {},
    popover: {
      width: '100%',
      padding: theme.spacing(2),
      top: '0px !important'
    },
    icon: {
      fill: theme.palette.common.black,
      width: 24,
      height: 24
    },
    portal: {
      position: 'fixed',
      width: '100%',
      zIndex: theme.zIndex.modal,
      background: theme.palette.background.paper,
      left: '50%',
      transform: 'translate(-50%, 0)',
      bottom: 0,
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    appHeader: (_appHeader = {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      minHeight: 109
    }, (0, _defineProperty2.default)(_appHeader, theme.breakpoints.down('xs'), {
      minHeight: 79
    }), (0, _defineProperty2.default)(_appHeader, '@media(max-width: 420px)', {
      minHeight: 60
    }), _appHeader),
    search: {
      width: '100%',
      '& > div': {
        margin: 0
      }
    }
  };
}, {
  name: 'SxMainNavigationNarrow'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_Close.default, null);

var _ref3 = /*#__PURE__*/_react.default.createElement(_Menu.default, null);

var MainNavigationNarrow = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var AppBarActions = _ref.appBarActions,
      buttonCloseIcon = _ref.buttonCloseIcon,
      buttonOpenIcon = _ref.buttonOpenIcon,
      pClasses = _ref.classes,
      className = _ref.className,
      Logo = _ref.logo,
      menuItems = _ref.menuItems,
      variant = _ref.variant,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["appBarActions", "buttonCloseIcon", "buttonOpenIcon", "classes", "className", "logo", "menuItems", "variant"]);
  var classes = useStyles({
    classes: pClasses
  });

  var rootRef = _react.default.useRef();

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = _react.default.useState(false),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      find = _React$useState4[0],
      setFind = _React$useState4[1];

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.appHeader,
    ref: rootRef
  }, /*#__PURE__*/_react.default.createElement(_IconButtonWithTooltip.default, {
    className: classes.menuButton,
    icon: open ? buttonCloseIcon || _ref2 : buttonOpenIcon || _ref3,
    color: "inherit",
    "aria-label": "Menu",
    onClick: function onClick() {
      return setOpen(function (p) {
        return !p;
      });
    }
  }), Logo && (!find || open) && /*#__PURE__*/_react.default.createElement(Logo, {
    onClick: function onClick() {
      return setOpen(false);
    }
  }), !open && find && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.search
  }, /*#__PURE__*/_react.default.createElement(_AppBarActionGlobalSearchComposed.default, {
    label: "Search items",
    variant: variant,
    onChange: function onChange() {
      return setFind(false);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, !find && /*#__PURE__*/_react.default.createElement(_IconButtonWithTooltip.default, {
    onClick: function onClick() {
      return setFind(true);
    },
    icon: /*#__PURE__*/_react.default.createElement(_Search.default, {
      style: {
        fill: 'black'
      }
    })
  }), /*#__PURE__*/_react.default.createElement(_AppBarActionCart.default, {
    variant: variant,
    path: "/cart/content",
    IconComponent: _BasketIcon.default,
    IconComponentProps: {
      className: classes.icon
    }
  }))), open && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.portal,
    style: {
      top: (rootRef.current || {}).offsetHeight || 50
    }
  }, /*#__PURE__*/_react.default.createElement(_AppBarActionNarrow.default, {
    onClose: function onClose() {
      return setOpen(false);
    }
  }), /*#__PURE__*/_react.default.createElement(_MobileMainNavigation.default, {
    menuItems: menuItems,
    setOpen: setOpen
  })));
});

process.env.NODE_ENV !== "production" ? MainNavigationNarrow.propTypes = {
  appBarActions: _propTypes.default.elementType,
  buttonCloseIcon: _propTypes.default.node,
  buttonOpenIcon: _propTypes.default.node,
  classes: _propTypes.default.shape({
    appHeader: _propTypes.default.string,
    icon: _propTypes.default.string,
    menuButton: _propTypes.default.string,
    portal: _propTypes.default.string,
    root: _propTypes.default.string,
    search: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  logo: _propTypes.default.elementType,
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired,
  variant: _propTypes.default.oneOf(['none', 'menuItem', 'standalone'])
} : void 0;
MainNavigationNarrow.defaultProps = {
  appBarActions: undefined,
  buttonCloseIcon: undefined,
  buttonOpenIcon: undefined,
  classes: undefined,
  className: undefined,
  logo: undefined,
  variant: 'standalone'
};
var _default = MainNavigationNarrow;
exports.default = _default;